// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"9ddf4ba5","80":"9bb32aee","370":"ad0fda0d","503":"bc419fcf","823":"49690ace"}[chunkId] + ".chunk.js";
};